const baseData = [
  { id: 1, name: "User Admin", email: "admin@siloam.id", role: "Admin", status: "Active", joined: "2026-03-15", password: "123456As!" },
  { id: 2, name: "User Guest", email: "guest@gmail.com", role: "Guest", status: "Active", joined: "2026-04-01", password: "123456As!" },
  { id: 3, name: "User Helper", email: "helper@outlook.com", role: "Helper", status: "Active", joined: "2026-04-10", password: "123456As!" },
];

export const userMockData = Array.from({ length: 90 }, (_, index) => {
  // Hitung jumlah data per kategori (misal: 90 data / 3 role = 30 data per role)
  const itemsPerRole = 30; 
  
  // Menentukan index baseData mana yang dipakai (0 untuk Admin, 1 untuk Guest, 2 untuk Helper)
  const baseIndex = Math.floor(index / itemsPerRole);
  const base = baseData[baseIndex];

  // Menentukan nomor urut untuk setiap kategori (1, 2, 3... sampai 30)
  const sequenceNumber = (index % itemsPerRole) + 1;

  const emailPrefix = base.email.split('@')[0];
  const emailDomain = base.email.split('@')[1];

  // Logika khusus: Jika nomor urut adalah 1, jangan tambahkan angka (agar email asli tetap bisa login)
  const isFirstOfRole = sequenceNumber === 1;

  return {
    id: index + 1,
    name: isFirstOfRole ? base.name : `${base.name} ${sequenceNumber}`,
    email: isFirstOfRole ? base.email : `${emailPrefix}${sequenceNumber}@${emailDomain}`,
    role: base.role,
    status: base.status,
    joined: base.joined,
    password: base.password,
    image: `https://i.pravatar.cc/150?u=${index + 1}`
  };
});